export default __webpack_public_path__ + "static/media/image_people-risks.a7bbe1d3.svg";